export default "__VITE_ASSET__BZpHj_rI__"